import Cookies from "js-cookie";
import { doPostCall } from "./config/rest";

function errorHandler(errorType, data){
    global.isSuccess = false;
    if(errorType === "SimilarProductError") {
        global.similarProduct = true;
        global.quantityMoreThanOne = false;
        global.unknownError = false;
        global.wordpressError = false;
    }
    else if(errorType === "QuantityMoreThanOneError") {
        global.quantityMoreThanOne = true;
        global.similarProduct = false;
        global.unknownError = false;
        global.wordpressError = false;
    }
    else if(errorType === "wordpressError"){
        global.wordpressError = true;
        global.unknownError = true;
        global.similarProduct = false;
        global.quantityMoreThanOne = false;
    }
    else if(errorType === "UnknownResourceError"){
        global.similarProduct = false;
        global.quantityMoreThanOne = false;
        global.unknownError = false;
        global.wordpressError = false;
        if(Cookies.get('user-oauth-token', { domain: '.efficientlearning.com' })){
            return createLoggedInCart(data);
        }
        else{
            return createAnonymousCart(data);
        }
    }
    else{
        global.unknownError = true;
        global.similarProduct = false;
        global.quantityMoreThanOne = false;
        global.wordpressError = false;
    }
}

function addToCartAnonymous(data) {
    return doPostCall(`/wp-json/hybris/v1/users/anonymous/carts/${Cookies.get('wel-cart', { domain: '.efficientlearning.com' })}/entries`, data)
    .then(function(response) {
        global.isSuccess = true;
        global.unknownError = false;
        global.similarProduct = false;
        global.quantityMoreThanOne = false;
        global.wordpressError = false;
        Cookies.set('wel-cart-total-items',response.data.totalItems, { domain: '.efficientlearning.com', expires: 14 })
        console.log(response)
        return response;
    })
    .catch(function(error) {
        if(error.response) {
            console.log(error.response.data.errors[0])
            return errorHandler(error.response.data.errors[0].type, data);
        }
    })
}
function addToCartLoggedIn(data, headers) {
    var inOneHour = 1/24;
    return doPostCall(`/wp-json/hybris/v1/users/current/carts/${Cookies.get('wel-cartid', { domain: '.efficientlearning.com' })}/entries`, data, headers)
    .then(function(response) {
        global.isSuccess = true;
        global.unknownError = false;
        global.similarProduct = false;
        global.quantityMoreThanOne = false;
        global.wordpressError = false;
        Cookies.set('wel-cart-total-items',response.data.totalItems, { domain: '.efficientlearning.com', expires: inOneHour })
        console.log(response)
        return response;
    })
    .catch(function(error) {
        if(error.response) {
            console.log(error.response.data.errors[0])
            return errorHandler(error.response.data.errors[0].type, data);
        }
    })
}
// create cart for anonymous user
function createAnonymousCart(data){
    return doPostCall("/wp-json/hybris/v1/users/anonymous/carts")
    .then(function (response) {
        console.log(response);
        Cookies.set('wel-cart-total-items',0, { domain: '.efficientlearning.com', expires: 14 })
        Cookies.set('wel-cart', `${response.data.guid}`, { domain: '.efficientlearning.com', expires: 14 });
        return addToCartAnonymous(data)
    })
    .catch(function (error) {
        console.log(error.response.data);
    });
}
// create cart for logged in user
function createLoggedInCart(data){
    let headers = {
        'Content-Type': 'application/json, application/xml',
        'Hybris-Authorization': 'Bearer '+ Cookies.get('user-oauth-token', { domain: '.efficientlearning.com' })
    }
    var inOneHour = 1/24;
    return doPostCall("/wp-json/hybris/v1/users/current/carts", null, headers)
    .then(function (response) {
        console.log(response);
        Cookies.set('wel-cart-total-items',0, { domain: '.efficientlearning.com', expires: inOneHour })
        Cookies.set('wel-cartid', `${response.data.code}`, { domain: '.efficientlearning.com', expires: inOneHour });
        return addToCartLoggedIn(data, headers)
    })
    .catch(function (error) {
        console.log(error.response.data);
    });
}

export function createCart(data){
    // loggedin user
    if(Cookies.get('user-oauth-token', { domain: '.efficientlearning.com' })){
        let headers = {
            'Content-Type': 'application/json, application/xml',
            'Hybris-Authorization': 'Bearer '+ Cookies.get('user-oauth-token', { domain: '.efficientlearning.com' })
        }
        // cart not already created
        if(!Cookies.get('wel-cartid', { domain: '.efficientlearning.com' })){
            return createLoggedInCart(data);
        }
        // cart already created
        else{
            return addToCartLoggedIn(data, headers)
        }
    }
    // anonymous user
    else{
        // cart not already created
        if(!Cookies.get('wel-cart', { domain: '.efficientlearning.com' })){
            return createAnonymousCart(data);
        }
        // cart already created
        else{
            return addToCartAnonymous(data)
        }
    }
}